<template>
<modal @close="onModalClose" :no-footer="true">
    <template slot="header">
        Setup StorEdge Tenants for Insurance
    </template>

    <template slot="content">
        <div>Setting up {{ tenants.length }} tenant<span v-if="tenants.length !== 1">s</span>.</div>

        <hr class="small" />

        <div v-for="(batch, index) in batches" :key="`batch-${index}`">
            <div v-if="batch.status === 'idle'" class="flex as-c">
                <span class="badge gray" title="Idle">
                    <span class="material-icons">hourglass_empty</span>
                </span>

                <div class="ml-2">Waiting</div>
            </div>

            <div v-else-if="batch.status === 'loading'" class="flex as-c">
                <span class="badge secondary" title="Loading">
                    <span class="material-icons">more_horiz</span>
                </span>

                <div class="ml-2">Setting up {{ batch.tenants.length }} tenants</div>
            </div>

            <div v-else-if="batch.status === 'error'" class="flex as-c">
                <span class="badge danger" title="Error">
                    <span class="material-icons">report_problem</span>
                </span>

                <div class="ml-2">{{ batch.error }}</div>
            </div>

            <div v-else-if="batch.status === 'complete'" class="flex as-c">
                <span class="badge primary" title="Complete">
                    <span class="material-icons">done</span>
                </span>

                <div class="ml-2">Complete</div>
            </div>
        </div>

        <hr class="small" />

        <div class="fs-09">Note: StorEdge tenants are setup in batches. As a result, individual setup statuses (i.e. <span class="danger-text">failures</span>) will not be shown here.</div>
    </template>
</modal>
</template>

<script>
import Vue from "vue"
import http from "@/http"
import { objectToParams } from "@/utilities/form-data"

export default {
    props: {
        batchSize: {
            default: 5,
            type: Number
        },

        tenants: {
            required: true,
            type: Array
        }
    },

    data () {
        return {
            batches: this.tenants.reduce((chunks, tenant) => {
                if (chunks.length === 0) {
                    chunks.push({ tenants: [], error: "", status: "idle" })
                }

                const lastIndex = chunks.length - 1

                if (chunks[lastIndex].tenants.length < this.batchSize) {
                    chunks[lastIndex].tenants.push(tenant)
                } else {
                    chunks.push({ tenants: [tenant], error: "", status: "idle" })
                }

                return chunks
            }, []),
            error: "",
            status: "loading"
        }
    },

    mounted () {
        Vue.nextTick(this.setupPolicies)
    },

    methods: {
        onModalClose () {
            if (!this.is_saving) {
                this.$emit("close")
            }
        },

        async setupPolicies () {
            // Because arrays are passed by reference, changes to `batch` will
            // be persistent.
            for (const batch of this.batches) {
                const ledgerIds = batch.tenants.map(({ ledger_id: ledgerId }) => ledgerId)

                batch.status = "loading"

                try {
                    await http.post("/api/tenants/setup-policies", objectToParams({
                        cycle_id: batch.tenants[0].cycle_id,
                        ledger_ids: ledgerIds.join(",")
                    }))

                    batch.status = "complete"
                } catch (ex) {
                    if (ex.message) {
                        batch.error = ex.message
                    } else {
                        batch.error = ex
                    }

                    batch.status = "error"
                }
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/insurance-policy-management-page/SetupStorEdgeTenantsModal.vue